<header class="io-bg-dark">
    <nav class="navbar navbar-expand-lg navbar-dark io-bg-dark">
        <div class="container">
            <a class="navbar-brand mr-xl-5" routerLink="/dashboard">
                <img src="assets/images/logo-white.png" style="min-width: 135.2px !important;"  height="40" class="d-inline-block align-top mr-2"
                    alt="insurEco Wallet">
            </a>
            <!--Desktop nav-->
            <div class="collapse navbar-collapse" id="navbarNavAltMarkup">
                <div class="navbar-nav">
                    <a class="nav-item nav-link" routerLink="/dashboard" routerLinkActive="active">
                        <i class='bx-fw bx bx-home-alt'></i>Dashboard
										</a>
										<a class="nav-item nav-link" routerLink="/workspace" routerLinkActive="active">
											<i class='bx-fw bx bx-task'></i>Workspace
										</a>
                    <a class="nav-item nav-link" routerLink="/commissions" routerLinkActive="active">
                        <i class='bx-fw bx bx-dollar-circle'></i>Commissions
                    </a>

                    <a class="nav-item nav-link" routerLink="/network" routerLinkActive="active">
                        <i class='bx-fw bx bx-group'></i>Network
                        <span *ngIf="invites?.length > 0" class="badge badge-pill badge-warning network-badge">{{invites?.length}}</span>
                                        </a>
                    <a class="nav-item nav-link" routerLink="/wallet" routerLinkActive="active">
                        <i class='bx-fw bx bx-wallet-alt'></i>Wallets
                    </a>
                </div>
            </div>

            <div class="notifications mr-3 ml-a">
                <a href="javascript:void" (click)="showNotificationsDrawer()" class="d-block text-white"><i class='bx bx-bell bx-fw '></i></a>
                <div class="dot" *ngIf="notificationCount>0"></div>
            </div>
            <!--Profile-->
            <div dropdown class="dropdown my-profile-btn">
                <button class="btn dropdown-toggle" dropdownToggle type="button">
                    <span class="avtar">
                        <ngx-avatar data-toggle="tooltip" data-placement="top" title="Hello, {{user.firstName}}"
                            src="{{user.avatar}}"
                            name="{{getInitials(user.firstName) + ' ' + getInitials(user.lastName)}}" initialsSize="2" size="35">
                        </ngx-avatar>
                    </span>
                </button>
                <div class="dropdown-menu mt-3 dropdown-menu-right" *dropdownMenu aria-labelledby="dropdownMenu2">
                    <button class="dropdown-item mb-2 disabled">Hello, {{user.firstName}}</button>
                    <button class="dropdown-item mb-2" type="button" routerLink="/user/profile">
                        <i class='bx bx-user bx-fw'></i> My profile
                    </button>
                    <button class="dropdown-item mb-2" type="button" (click)="showChangePasswordModal()">
                        <i class='bx bx-lock-alt bx-fw'></i> Change password
                    </button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item mb-2" type="button" routerLink="/settings/programs">
                        <i class='bx bx-grid-alt bx-fw'></i> Manage programs
                    </button>
                    <button class="dropdown-item mb-2" type="button" routerLink="/settings/organization">
                        <i class='bx bx-cog bx-fw'></i> Settings
                    </button>
                    <div class="dropdown-divider"></div>
                    <button (click)="logout()" class="dropdown-item mb-2" type="button">
                        <i class='bx bx-log-out bx-flip-horizontal bx-fw'></i> Logout</button>
                </div>
            </div>
        </div>
    </nav>
    <!--Mobile bottom nav-->
    <div class="m-bottom-nav bg-white shadow-lg d-lg-none">
        <a routerLink="/dashboard" routerLinkActive="active">
            <i class='bx bx-home-alt'></i>
            <span>Dashboard</span>
        </a>
        <a routerLink="/commissions" routerLinkActive="active">
            <i class='bx bx-dollar-circle'></i>
            <span>Commissions</span>
        </a>
        <a routerLink="/network" routerLinkActive="active">
            <i class='bx bx-group'></i>
            <span>Network</span>
            <span *ngIf="invites?.length > 0" class="badge badge-pill badge-warning network-badge-mobile">{{invites?.length}}</span>
        </a>
        <a routerLink="/wallet" routerLinkActive="active">
            <i class='bx bx-wallet-alt'></i>
            <span>Wallet</span>
        </a>
        <a routerLink="/settings/organization" routerLinkActive="active">
            <i class='bx bx-cog'></i>
            <span>Settings</span>
        </a>
    </div>
</header>
<!--Header end -->
